/**
 * Types of the deterministic (rule-based) screening engine.
 * The result shape is the same JSON the CRM contact form imports.
 */

export const CATEGORIES = ["vision", "finance", "implementation", "risks", "operations"] as const;
export type Category = typeof CATEGORIES[number];

export type ContactKind = "Osoba" | "Společnost" | "Lead";

export type CategoryScores = Record<Category, number>;
export type CategoryNotes = Record<Category, string>;

/** A single rule that fired while scoring a category. */
export interface Evidence {
    /** Czech label shown to the user, e.g. "měřitelný cíl". */
    label: string;
    /** Points added to (positive) or removed from (negative) the category score. */
    weight: number;
}

export interface ExtractedMetrics {
    revenue: number | null;
    profit: number | null;
    budget: number | null;
    equity: number | null;
    assets: number | null;
    roiMonths: number | null;
    growthPercent: number | null;
    riskProbabilityPercent: number | null;
    implementationWeeks: number | null;
    phases: number | null;
    amountsFound: number;
}

export interface ScreeningResult {
    fullname: string;
    email: string;
    phone: string;
    ico: string;
    kind: ContactKind;
    /** Overall score 0–100: plain average of the category scores (same formula as the CRM form). */
    score: number;
    /** Key financial figure found in the document (revenue, budget or the largest amount). */
    price: string;
    scores: CategoryScores;
    notes: CategoryNotes;
    /** Executive summary with the recommendation. */
    analysis_finance: string;
    evidence: Record<Category, Evidence[]>;
    /** Whether the document contains any information about the category. */
    coverage: Record<Category, boolean>;
    redFlags: string[];
    metrics: ExtractedMetrics;
    engineVersion: string;
}
